import React, { useEffect, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, Animated, Modal, Dimensions } from 'react-native';
import Icon from '../../icon/Icon';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import Divider from '../../divider/Divider';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import ShortfallContent from './ShortfallContent';
import { showInterestCalculator } from '../utils';
const EmptyScreen = ({ activeTab, searchText, navigateToInterestCalculator, isFilterSelected, navigateToCustomerScreen, navigateToInterestScreen, navigateToRenewalScreen, navigateToShortfallScreen, setIsFilterSelected, setNewFilterObj, triggerAction, }) => {
    const [showShortfallInfo, setShowShortfallInfo] = useState(false);
    const [showInterestCal, setShowInterestCal] = useState(showInterestCalculator());
    const screenWidth = Dimensions.get('window').width;
    const handleShortfallInfo = () => {
        setShowShortfallInfo(true);
    };
    const opacity = new Animated.Value(0);
    const translateY = new Animated.Value(100);
    useEffect(() => {
        if (showShortfallInfo) {
            handleAnimation(1);
        }
        else {
            handleAnimation(0);
        }
    }, [showShortfallInfo]);
    const handleCloseShortfallContent = () => {
        setShowShortfallInfo(false);
    };
    const handleAnimation = (toValue) => {
        Animated.parallel([
            Animated.timing(opacity, {
                toValue,
                duration: 300,
                useNativeDriver: true,
            }),
            Animated.timing(translateY, {
                toValue,
                duration: 300,
                useNativeDriver: true,
            }),
        ]).start();
    };
    const renderModalContent = () => {
        return (React.createElement(Modal, { transparent: true, visible: showShortfallInfo, animationType: "none" },
            React.createElement(View, { style: [styles.modalBackground, { paddingRight: screenWidth <= 1600 ? 0 : (screenWidth - 1600) / 2 }] },
                React.createElement(Animated.View, { style: { opacity, transform: [{ translateY }] } },
                    React.createElement(ShortfallContent, { onClose: handleCloseShortfallContent, triggerAction: triggerAction })))));
    };
    const removeFilter = async () => {
        setIsFilterSelected(false);
        setNewFilterObj({});
        if (activeTab === 1) {
            await triggerAction({
                ...navigateToInterestScreen,
                payload: {
                    searchText,
                    ...navigateToInterestScreen.payload
                }
            });
        }
        else if (activeTab === 2) {
            await triggerAction({
                ...navigateToRenewalScreen,
                payload: {
                    searchText,
                    ...navigateToRenewalScreen.payload
                }
            });
        }
        else if (activeTab === 3) {
            await triggerAction({
                ...navigateToShortfallScreen,
                payload: {
                    searchText,
                    ...navigateToShortfallScreen.payload
                }
            });
        }
        else {
            await triggerAction({
                ...navigateToCustomerScreen,
                payload: {
                    searchText,
                    ...navigateToCustomerScreen.payload
                }
            });
        }
    };
    return (React.createElement(View, { style: { marginTop: 60, alignItems: 'center' } },
        React.createElement(Icon, { name: IconTokens.PENDING_LIST, size: IconSizeTokens.SIZE_164 }),
        React.createElement(View, { style: { marginTop: 24 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: activeTab === 2 ? 'No customers pending renewal' : 'No customer found', color: ColorTokens.Grey_Night })),
        isFilterSelected && React.createElement(View, { style: { marginTop: 8 } },
            React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.TERTIARY, label: 'Clear Filter', onPress: removeFilter, isDisabled: false })),
        showInterestCal && activeTab === 1 && React.createElement(View, { style: { marginTop: 60, backgroundColor: '#FFFFFF', borderWidth: 1, borderColor: '#E4E7EC', borderRadius: 8, elevation: 4, shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.25, shadowRadius: 4, paddingHorizontal: 16, paddingTop: 16 } },
            React.createElement(Icon, { name: IconTokens.INTEREST_CALCULATOR_DASHBOARD, size: IconSizeTokens.SIZE_164 }),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Interest & emi calculator', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Calculate loan interest rate and monthly emi amount', color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: { marginTop: 20, marginHorizontal: -16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, { style: {} },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.TERTIARY, label: 'Calculate now', onPress: async () => {
                        await triggerAction(navigateToInterestCalculator);
                    }, isDisabled: false }))),
        activeTab === 3 &&
            React.createElement(View, { style: { marginTop: 72, backgroundColor: '#F3F5FC', borderColor: '#E4E7EC', borderRadius: 8, padding: 12, flexDirection: 'row', alignItems: 'center' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'What is shortfall?', color: ColorTokens.Grey_Night }),
                React.createElement(TouchableOpacity, { style: { marginLeft: 4 }, onPress: handleShortfallInfo },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2B, label: 'Know More', color: ColorTokens.Primary_100 }))),
        showShortfallInfo && renderModalContent()));
};
const styles = StyleSheet.create({
    modalBackground: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default EmptyScreen;
